import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import axios from "axios";

export class FeedbackService {
    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
        this.cancelToken = null
    }

    getFeedbacksList(fundId, page, filter, size = 20) {
        if (this.cancelToken) {
            this.cancelToken()
        }
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundId}/critics-and-suggestions`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size,
                    ...filter
                },
                {},
                {
                    cancelToken: new axios.CancelToken(cancel => this.cancelToken = cancel)
                }
            ).then(resolve).catch(reject)
        })
    }

    getFeedbackInfo(fundID, feedbackId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/critics-and-suggestions/${feedbackId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    changeFeedbackState(fundID, feedbackId, status) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${fundID}/critics-and-suggestions/${feedbackId}/status/${status}`,
            this.httpClient.prepareUserAccessHeader(this.token),
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی وضعیت انتقاد و پیشنهاد با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بروزرسانی وضعیت انتقاد و پیشنهاد!"))
            this.loading(setLoadingStateDispatch(false))
        })
    }
}